import React from "react";
import { Input, Row, Typography, Select, Form, Divider, Col, InputNumber } from "antd";
import { labelConfig, staticConfig } from "../../../product.config";
import { BOM } from "../../../../../services/definedMethod";
const { Title } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    interestCompoundingPeriodTypeOptions,
    interestPostingPeriodTypeOptions,
    interestCalculationTypeOptions,
    interestCalculationDaysInYearTypeOptions,
  } = props;

  const checkForfeitInterest = Form.useWatch("forfeitInterest", form);
  const interestPostingPeriodType = Form.useWatch("interestPostingPeriodType", form);
  const interestPostingTypeIsMonthly = interestPostingPeriodType === 4;
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.interestInfo}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.norminalAnnualInterest}
            name={"nominalAnnualInterestRate"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCompoundingPeriod}
            name={"interestCompoundingPeriodType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              options={interestCompoundingPeriodTypeOptions}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestPostingPeriod}
            name={"interestPostingPeriodType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              options={interestPostingPeriodTypeOptions}
            />
          </Form.Item>
        </Col>
        {interestPostingTypeIsMonthly && (
          <>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item name={"forfeitInterest"} label={"Forfeit Interest for Withdrawals"}>
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
                  }
                  showSearch
                  allowClear
                  placeholder="Select Option"
                  options={staticConfig.yesOrNo}
                  // onChange={handleDormancyTracking}
                />
              </Form.Item>
            </Col>
            {checkForfeitInterest && (
              <>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld("Number of Withdrawals Threshold"),
                      },
                    ]}
                    label={"Number of Withdrawals Threshold"}
                    name={"withdrawalCount"}
                  >
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </>
            )}
          </>
        )}
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculatedUsing}
            name={"interestCalculationType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              options={interestCalculationTypeOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.daysInYear}
            name={"interestCalculationDaysInYearType"}
            rules={[
              {
                required: true,
                message: "Required Field",
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(input?.toLowerCase())
              }
              showSearch
              options={interestCalculationDaysInYearTypeOptions}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TermsForm;
